import RewardsStoreCard from './RewardsStoreCard';

export default RewardsStoreCard;
